module.exports = {"id":"232437","name":"Federico Ricca","rating":"74","photo":"./data/images/photos/2/232437.png","club":{"name":"Málaga CF","logo":"./data/images/clubs/MalagaCF.png"},"positions":["DG","DC","DLG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FedericoRicca0.json
// module id = 1387
// module chunks = 0